import * as React from 'react';

export function IconFamily(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg width={25} height={22} {...props}>
            <path
                fillRule="evenodd"
                fill="#2AAEF5"
                d="M23.295 14.385h-.006v3.997c0 .665-.523 1.203-1.169 1.203h-1.794c-.646 0-1.169-.538-1.169-1.203v-3.997h-.006a1.203 1.203 0 01-1.205-1.204V7.538c0-.665.538-1.204 1.205-1.204h4.146c.664 0 1.203.539 1.203 1.203v5.643c0 .666-.539 1.205-1.205 1.205zm-2.071-8.438a1.964 1.964 0 110-3.929 1.964 1.964 0 010 3.929zM14.92 15.18h-.007v4.666c0 .776-.612 1.404-1.367 1.404h-2.092c-.756 0-1.366-.628-1.366-1.404V15.18h-.008a1.405 1.405 0 01-1.405-1.404V7.191c0-.776.63-1.404 1.405-1.404h4.839c.776 0 1.405.628 1.406 1.404v6.585c0 .776-.629 1.404-1.405 1.404zM12.5 5.334a2.292 2.292 0 110-4.585 2.292 2.292 0 010 4.585zm-6.651 9.051h-.006v3.997c0 .665-.524 1.203-1.169 1.203H2.88c-.646 0-1.17-.538-1.17-1.203v-3.997h-.006A1.204 1.204 0 01.5 13.181V7.537c0-.664.539-1.203 1.204-1.203H5.85c.665 0 1.202.539 1.202 1.203v5.643c0 .666-.538 1.205-1.203 1.205zM3.777 5.946a1.964 1.964 0 110-3.927 1.964 1.964 0 010 3.927z"
            />
        </svg>
    );
}




// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/IconFamily.tsx